import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

// Handles the inline edit modal for Production Track (job) rows.
// On row click: loads the edit form from the server via Turbo Frame.
// On frame render: shows the dialog and initializes flatpickr on date/time inputs.
// Form submits via Turbo; controller responds with turbo_stream (replace row, clear modal, toast).
export default class extends Controller {
  static targets = ["dialog", "errors", "dateInput", "timeInput"]

  connect() {
    this.flatpickrInstances = []
    this.boundOnFrameRender = this.onFrameRender.bind(this)
    document.addEventListener("turbo:frame-render", this.boundOnFrameRender)
  }

  disconnect() {
    document.removeEventListener("turbo:frame-render", this.boundOnFrameRender)
    this.destroyFlatpickr()
  }

  onFrameRender(event) {
    if (event.target.id !== "production-track-edit-modal-frame") return
    this.initFlatpickrInForm()
    if (this.hasDialogTarget) this.dialogTarget.showModal()
  }

  initFlatpickrInForm() {
    this.destroyFlatpickr()
    const appendTo = this.hasDialogTarget ? this.dialogTarget : undefined
    this.dateInputTargets.forEach((input) => {
      this.flatpickrInstances.push(flatpickr(input, {
        dateFormat: "Y-m-d",
        allowInput: true,
        disableMobile: true,
        appendTo
      }))
    })
    this.timeInputTargets.forEach((input) => {
      this.flatpickrInstances.push(flatpickr(input, {
        enableTime: true,
        noCalendar: true,
        dateFormat: "h:i K",
        time_24hr: false,
        allowInput: true,
        disableMobile: true,
        appendTo
      }))
    })
  }

  destroyFlatpickr() {
    this.flatpickrInstances?.forEach((instance) => instance.destroy())
    this.flatpickrInstances = []
  }

  open(event) {
    if (event.target.closest("[data-handle]")) return

    const row = event.currentTarget
    const editUrl = row.dataset.editUrl

    if (!editUrl) return

    this.clearErrors()
    Turbo.visit(editUrl, { frame: "production-track-edit-modal-frame" })
  }

  close() {
    if (this.hasDialogTarget) this.dialogTarget.close()
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  clearErrors() {
    if (this.hasErrorsTarget) {
      this.errorsTarget.textContent = ""
      this.errorsTarget.classList.add("hidden")
    }
  }
}
